<template>
  <layout-combined-default :meals="meals" />
</template>

<script>
import LayoutCombinedDefault from "./layout-combined-default"

export default {
  maxMeals: LayoutCombinedDefault.maxMeals,
  slicer: LayoutCombinedDefault.slicer,
  name: "layout-combined-black",
  props: ["meals"],
  components: { LayoutCombinedDefault }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.layout {
  background-color: black;
  color: white;
}
::v-deep .meals {
  .meal-allergens {
    color: lightgray;
  }
}
</style>
